
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import i18n from 'i18next';

import routes from "./routes";
import './App.scss';
import { setUserState, setVatToken } from "./store/application";
import { MiniCart } from "./components/shared/sections/mini-cart";
import { MiniCartMobile } from "./components/shared/sections/mini-cart/mobile";
import { addEventListener } from './utils/dom';
import { RootState } from "./store";
import { Page } from "./enums/page";
import SessionValidationWrapper from "./utils/validation/session";
import { get as getCookie} from "../src/utils/cookies";

declare const window: any;

const initialUserState: any = window.initialUserState;
function App({ ROUTE_LOCALE }: any) {
  
  const dispatch = useDispatch();
  useEffect(() => {
    setInitialState()
   
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
const setInitialState=()=>{
  i18n.changeLanguage(window.np.getLocale());
  const userinfo=window.np.getUserInfo()
  initialUserState.isLoggedIn=userinfo.isLoggedIn.toString();

  if(!initialUserState.userId || initialUserState.userId === null || initialUserState.userId === '') {
    initialUserState.userId= initialUserState.isLoggedIn==='true' ? userinfo.userId : userinfo.anonymousId;
  }

  if(!initialUserState.cartId || initialUserState.cartId === null || initialUserState.cartId === '') {
    const cartId = getCookie('np.cartId');
    if(cartId){
      initialUserState.cartId=cartId;
    }
  }

  dispatch(setUserState(initialUserState));
  dispatch(setVatToken(initialUserState.vatToken));
}
  const {
    applicationState: { currentPage },
  } = useSelector((state: RootState) => state);

  const [IsMiniCartOpen, setMiniCartOpenState] = useState(false);
  const globalClickHandler = () => IsMiniCartOpen && setMiniCartOpenState(false);

  ["header-all-categories-link", "countries-dropdown-window"].forEach((link)=> addEventListener(document.getElementById(link), 'click', globalClickHandler));

  addEventListener(null, 'click', (event) => {
    let target = event.target;
    let canCall = true;
    while (target) {
      if (target?.classList?.contains('mini-cart')) {
        canCall = false;
        break;
      }
      target = target.parentNode;
    }

    if (canCall) {
      globalClickHandler();
    }
    event.stopPropagation();
  });

  return (
    <>
      <div>
        <BrowserRouter>
          <SessionValidationWrapper>
            <Routes>
              {routes.map(route =>
                <Route path={`/${route.region}/${encodeURI(route.path)}`} key={route.path} element={<route.component {...window.initialUserState}  title={route.title}/>} ></Route>
              )}
            </Routes>
          </SessionValidationWrapper>
        </BrowserRouter>
      </div>
      {currentPage !== Page.ORDERCONFIRMATION && <> <MiniCart IsMiniCartOpen={IsMiniCartOpen} setMiniCartOpenState={setMiniCartOpenState} />
        <MiniCartMobile /> </>}
    </>

  );
}

export default App;
